import React from "react";
var __jsx = React.createElement;
export default function IconR() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9",
    height: "14",
    viewBox: "0 0 9 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70603 11.4168C6.55287 11.4673 6.94404 11.8855 6.82217 12.189C6.6993 12.4925 5.83608 13.2548 4.38507 13.4585C2.93509 13.6621 1.49945 13.5692 0.951606 13.5692C0.404802 13.5692 -0.242362 13.4941 0.0914503 13.2182C0.867661 12.608 1.7501 12.136 2.69752 11.8242C3.97035 11.4158 4.8602 11.3644 5.70603 11.4158V11.4168ZM8.72067 7.78242C8.66333 8.13638 8.28342 9.03805 7.18775 9.72223C6.31735 10.268 5.32407 10.6585 4.26628 10.8681C3.48088 11.0283 2.73849 11.2468 2.98424 10.8019C3.22999 10.357 4.06149 9.2526 5.26366 8.47648C6.46585 7.70037 7.0997 7.60841 7.63422 7.49965C8.16978 7.39091 8.77803 7.43046 8.72069 7.78341L8.72067 7.78242ZM8.35203 4.12428C8.79338 4.12428 8.76368 4.51778 8.64591 4.85592C8.52713 5.19207 8.0223 6.19559 7.15088 6.80659C6.56926 7.21294 5.83299 7.5659 4.94212 7.86448C5.14077 6.77198 5.56677 5.91282 6.22007 5.28797C7.19902 4.3497 7.91069 4.12528 8.35203 4.12528V4.12428ZM6.37265 1.21162C6.51477 1.19835 6.6572 1.23369 6.77508 1.31148C6.82906 1.34656 6.87476 1.39227 6.90917 1.4456C6.94358 1.49893 6.96593 1.55868 6.97475 1.62094L6.99319 1.79494C7.04233 2.35453 6.95224 2.91611 6.73002 3.44605C6.3921 4.24689 5.8842 4.88261 5.20837 5.34926C5.07525 4.92216 4.9923 4.56821 4.96261 4.28545C4.91755 3.86031 4.91755 3.47669 5.20836 2.5068C5.33738 2.07572 5.61796 1.68618 6.04803 1.33817C6.14041 1.26513 6.25364 1.22099 6.37265 1.21162Z",
    fill: "url(#paint0_linear_6559_5169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12935 8.29915e-05C4.03016 0.00159154 3.92946 0.0343594 3.84481 0.0926668C3.77337 0.140575 3.71689 0.204751 3.6829 0.276644C3.52725 0.615546 3.47875 0.922399 3.53869 1.19646C3.67323 1.81326 3.79845 2.01569 3.96543 2.22377C4.07632 2.36226 4.24379 2.51909 4.46655 2.69642C4.73732 2.20618 4.84777 1.68736 4.79792 1.14277C4.76405 0.782889 4.63714 0.454023 4.42371 0.176467L4.35537 0.0912995C4.32953 0.0616327 4.29603 0.0381703 4.25708 0.0224505C4.21813 0.00673063 4.1746 -0.000891837 4.12935 8.29915e-05Z",
    fill: "url(#paint1_linear_6559_5169)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6559_5169",
    x1: "4.9128",
    y1: "28.7796",
    x2: "-5.4602",
    y2: "-4.74188",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#E7D2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.371018",
    "stop-color": "#E5C28F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.870192",
    "stop-color": "#A96500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6559_5169",
    x1: "4.9128",
    y1: "28.7796",
    x2: "-5.4602",
    y2: "-4.74188",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#E7D2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.371018",
    "stop-color": "#E5C28F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.870192",
    "stop-color": "#A96500"
  }))));
}
IconR.displayName = "IconR";